import React from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, LinearProgress } from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { CustomPostAddress } from 'api/types/CustomPostAddress';
import FormikTextField from 'components/atoms/FormikInput/FormikInput';
import { savePostAddress } from '../../../api/address';
import { useStyles } from './styles';
import { Props } from './props';

export const PostAddressDialog: React.FC<Props> = ({
    onClose,
    orderNumber,
    receiptDate,
    regionDescription,
    open,
}) => {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();

    const form: CustomPostAddress = {
        order_number: orderNumber,
        receipt_date: receiptDate,
        address: '',
        region: regionDescription,
        old_post_code: '',
        new_post_code: '',
    };

    const schema = () =>
        Yup.object().shape({
            address: Yup.string().required('Введите адрес'),
            old_post_code: Yup.string()
                .min(6, 'Вы не можете ввести меньше 6-ти символов')
                .max(6, 'Вы не можете ввести больше 6-ти символов')
                .required('Введите старый почтовый индекс'),
            new_post_code: Yup.string()
                .max(7, 'Вы не можете ввести больше 7-ми символов')
                .min(7, 'Вы не можете ввести меньше 7-ми символов'),
        });

    return (
        <Dialog open={open} onClose={() => onClose()} fullWidth>
            <DialogTitle>Редактирование адреса вручную</DialogTitle>
            <DialogContent>
                <Formik
                    enableReinitialize={true}
                    initialValues={form}
                    validationSchema={schema()}
                    onSubmit={async (values, { setSubmitting }) => {
                        setSubmitting(true);
                        try {
                            const res = await savePostAddress(values);
                            onClose(res);
                            enqueueSnackbar('Данные успешно сохранены', { variant: 'success' });
                        } catch (e) {
                            enqueueSnackbar(
                                `Ошибка при сохранении данных: ${e.response?.data?.message || e}`,
                                {
                                    variant: 'error',
                                }
                            );
                        } finally {
                            setSubmitting(false);
                        }
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Box display="flex" flexDirection="column">
                                <Field
                                    className={classes.mt2}
                                    component={FormikTextField}
                                    name="address"
                                    label="Адрес"
                                />
                                <Field
                                    className={classes.mt2}
                                    component={FormikTextField}
                                    name="old_post_code"
                                    label="Старый почтовый индекс"
                                />
                                <Field
                                    className={classes.mt2}
                                    component={FormikTextField}
                                    name="new_post_code"
                                    label="Новый почтовый индекс"
                                />
                            </Box>
                            <Box>{isSubmitting && <LinearProgress />}</Box>
                            <Box marginTop={3} display="flex" justifyContent="flex-end">
                                <Button onClick={() => onClose()}>Отмена</Button>
                                <Button type={'submit'}>Ок</Button>
                            </Box>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};
